import {CitiesResult, SET_CITIES, SetCities} from "../types/CitiesTypes";


export const setCities = (data: CitiesResult): SetCities => ({
    type: SET_CITIES,
    data: data
});